export default function notificationBar(text, type) {
	const container = document.createElement('div');
	document.body.appendChild(container);

	const classNames = `notification-bar notification-bar--${type}`;

	container.innerHTML = `
    <div class="${classNames}">
      <p class="notification-bar__text">${text}</p>
    </div>
  `;

	setTimeout(() => {
		container.remove();
	}, 5000);
}
